export const WisdomModules = {
  perksAndDiscounts: "perks-and-discounts",
  videoChat: "video-chat",
  moodTracker: "mood-tracker",
  achievements: "achievements",
  fourWeekPlan: "four-week-plans",
  leaderBoards: "leaderboards",
  trackers: "wellbeing-trackers",
  miniHealthChecks: "mini-health-checks",
  liveChat: "live-text-chat",
  requestCallBack: "request-call-back",
  helpline: "helpline",
  whatsapp: "whatsapp",
  studentHub: "student-hub",
  wisdomAcademy: "academy",
} as const;

export const clientTypes = {
  STANDARD_CLIENT: "standard-client",
  WISDOM_LITE: "wisdom-lite",
};

export const communicationTypes = {
  PUSH_NOTIFICATION: "push-notification",
  EMAIL: "email",
};

export const notificationTypes = {
  IMMEDIATE: "immediate-notification",
  SCHEDULED: "scheduled-notification",
};

export const communicationEmailGroups = {
  PRODUCT_UPDATES: "00C0DA7A-D8A1-4E0B-AA08-862A7D551FEB",
  PERKS_AND_DISCOUNTS: "F52F64E5-DAB8-4898-B171-CC5544B2DE8D",
};

export const communicationSendOptions = {
  ALL_USERS: "all-users",
  SPECIFIC_CLIENT: "specific-client",
  SPECIFIC_TARGET_GROUP: "specific-target-group",
  SPECIFIC_LOCATION: "specific-location",
  ONLY_PERKS_AND_DISCOUNT: "only-perks-and-discounts",
};

export const modulePermissions = {
  legalInformation: ["en"],
  financialWellbeing: ["en"],
  liveChat: ["en"],
  videoChat: ["en"],
  safeSpaces: ["en"],
  acknowledgement: ["en_AU"],
  whatsApp: ["en"],
};

export type ModulePermissionKeys = keyof typeof modulePermissions;

export type WisdomModule = (typeof WisdomModules)[keyof typeof WisdomModules];
